import NotFoundComponent from './NotFound.vue';

export const notFoundRoutes = {
  path: '*',
  component: NotFoundComponent
};
